import React from 'react'
import BlogContents from '../component/BlogContents'
import Newsletter from '../component/Newsletter'
import WhatsappButton from '../component/WhatsappButton'

const Blog = () => {
  return (
    <main className="main__content_wrapper">
    <section className="breadcrumb__section breadcrumb__bg">
      <div className="container">
        <div className="row row-cols-1">
          <div className="col">
            <div className="breadcrumb__content">
              <h1 className="breadcrumb__content--title text-white mb-10">
                Blog Grid
              </h1>
              <ul className="breadcrumb__content--menu d-flex">
                <li className="breadcrumb__content--menu__items">
                  <a className="text-white" href="/">Home</a>
                </li>
                <li className="breadcrumb__content--menu__items">
                  <span className="text-white">Blog Grid</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="blog__section section--padding">
      <div className="container">
        <div className="section__heading text-center mb-40">
          <h2 className="section__heading--maintitle">Latest Post From Blog</h2>
        </div>
        <div className="blog__section--inner p-0">
        
          <BlogContents />
        </div>
      </div>
    </section>
  <Newsletter />
  <WhatsappButton />
  </main>
  )
}

export default Blog